import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=fac7ad06&"
import script from "./Articles.vue?vue&type=script&lang=ts&"
export * from "./Articles.vue?vue&type=script&lang=ts&"
import style0 from "./Articles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports